module.exports = __webpack_public_path__ + "static/media/8_l_stolb_11.46_41.85.c9ae0953.png";